import { useContext } from 'react';
import { SessionContext } from '../context/SessionProvider';

export interface SessionContextValue {
  // State
  isAuthenticated: boolean;
  isAuthenticating: boolean;
  isQuerying: boolean;
  init: { headers: { Authorization: string } } | undefined;
  groupsList: unknown[] | null;
  workspacePeopleList: unknown[] | null;
  rootWorkspaceDetails: Record<string, unknown> | null;
  currentItem: unknown;
  // Methods
  initiateSession: () => Promise<void>;
  updateCurrentSession: () => Promise<unknown>;
  updateGroupsList: (repeatGroupId?: unknown, counter?: number) => Promise<void>;
  updateCurrentUserInfo: (shouldRepeat: boolean, counter: number) => Promise<void>;
  getWorkspacePeopleList: () => Promise<void>;
  userHasAuthenticated: (auth: boolean) => void;
  updateIsQuerying: (querying: boolean) => void;
  updateLoginProcessOngoing: (ongoing: boolean) => void;
  updateRootWorkspaceDetails: (details: unknown) => void;
  updateCurrentItem: (item: unknown) => void;
  handleLogout: (noRedirect?: boolean) => Promise<void>;
}

export function useSession(): SessionContextValue {
  const context = useContext(SessionContext) as SessionContextValue | null;
  if (!context) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return context;
}
